<template>
  <div class="autobookpro-page-content book-order-box" v-if="isReady">
    <q-header elevated  class="book-order-header bg-white">
        <div class="row justify-center items-center">
          <div class="book-order-header-content">
            <div class="text-center book-order-logo-box q-py-sm">
              <img class="q-pl-sm" src="../../assets/rr-logo.jpg"/>
            </div>
          </div>
        </div>
        <div class="autobookpro-page-content">
          <q-tabs
            v-model="step"
            dense
            active-color="brand7"
            indicator-color="brand5"
            align="justify"
            narrow-indicator
            content-class="text-brand7"
          >
            <q-tab name="1" label="Shipping Information" class="text-black"/>
            <q-tab
              name="2"
              label="Terms and Conditions"
              class="text-black"
              :disable="dirty.shipper === true"
            />
            <q-tab
              name="3"
              label="Billing Information"
              class="text-black"
              :disable="(dirty.shipper === true) || (dirty.terms === true)"
            />
          </q-tabs>
        </div>
    </q-header>

    <div v-if="!invalidLink && !isBooked">
        <div class="row">
          <div class="col-md-12 col q-mt-lg q-px-sm">
            <div class="row items-center">
              <div class="border-brand6 heading-text">
                <div
                  class="text-bold text-brand7">
                  Complete your booking by filling out the information below.
                  Call us if you have any questions
                  <span class="text-brand5 dialable-box" @click="dialPhone">
                    {{callNumberDisplay}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <q-separator/>
        <div class="row  book-order-main q-mt-md" :class="{book_order_main_first:+step === 1}">
          <div class="col-md-9 col-12 q-px-sm">
            <q-tab-panels v-model="step" animated class="q-p-none">
              <q-tab-panel name="1" class="q-p-none expansion-list-panel">
                 <q-list class="expansion-list">
                     <q-card flat bordered>
                        <q-card-section class="q-pa-sm text-brand7 bg-grey-2 q-pb-md">
                          <div class="q-px-sm">
                            <q-icon name="perm_identity" size="1.5em"></q-icon>
                            <span class="semi-bordered-bottom text-bold text-h6 q-ml-lg">
                              Shipper Details
                            </span>
                          </div>
                        </q-card-section>
                        <q-separator />
                        <q-card-section class="q-pa-none">
                          <app-book-order-customer-info
                            :value="shipper"
                            @input="
                              shipper = $event;
                              setDirty('shipper')
                            "
                            :validation="$v.shipper"
                          />
                        </q-card-section>
                     </q-card>
                      <q-card flat bordered class="q-mt-sm">
                        <q-card-section class="q-pa-sm text-brand7 bg-grey-2 q-pb-md">
                          <div class="q-px-sm">
                            <q-icon name="route" size="1.5em"></q-icon>
                            <span class="semi-bordered-bottom text-bold text-h6 q-ml-lg">
                              Route Information
                            </span>
                          </div>
                        </q-card-section>
                        <q-separator />
                        <q-card-section class="q-pa-none">
                          <div class="row">
                            <div class="col-sm-6 col-12 q-px-sm">
                              <app-book-order-location-info
                                label="Pick-Up"
                                :value="origin"
                                @input="
                                  origin = $event;
                                  setDirty('shipper')
                                "
                                @clickSameAsShipper="copyShipperToLocation"
                                :validation="$v.origin"
                              />
                            </div>
                            <div class="col-sm-6 col-12 q-px-sm">
                              <app-book-order-location-info
                                label="Delivery"
                                :value="destination"
                                @input="
                                  destination = $event;
                                  setDirty('shipper')
                                "
                                :validation="$v.destination"
                                @clickSameAsShipper="copyShipperToLocation"
                              />
                            </div>
                          </div>
                        </q-card-section>
                     </q-card>
                </q-list>

              </q-tab-panel>

              <q-tab-panel name="2">
                <q-card flat bordered class="q-mb-sm">
                  <q-card-section class="q-pa-md bg-grey-2">
                    <div class="text-bold text-brand7">
                      Please read and sign our terms and conditions to
                      move forward with your booking
                    </div>
                  </q-card-section>
                </q-card>
                <app-terms-and-condition-card
                  context="book"
                  :value="terms"
                  @input="
                    terms = $event;
                    setDirty('terms')
                  "
                  :validation="$v.terms"
                  color="brand6"
                />
              </q-tab-panel>

              <q-tab-panel name="3">
                <q-card flat bordered class="q-mb-sm">
                  <q-card-section class="text-black">
                    <div class="text-bold text-brand7">
                      Your credit card will not be charged until a certified carrier is
                      assigned to your transport. The site is secured with 256-bit SSL
                      Encryption Protocol. Your info is safe
                    </div>
                  </q-card-section>
                </q-card>

                <div :class="billingInfoClass">
                  <div class="col">
                    <app-book-order-billing-address
                      :value="billingAddress"
                      @input="
                        billingAddress = $event;
                        setDirty('billing')
                      "
                      @use-info="handleUseInfo"
                      :validation="$v.billingAddress"
                    />
                  </div>
                  <div class="col" style="display:flex">
                    <app-book-order-credit-card-details
                      :value="creditCard"
                      @input="
                        creditCard = $event;
                        setDirty('billing')
                      "
                      :validation="$v.creditCard"
                    />
                  </div>
                </div>
              </q-tab-panel>
            </q-tab-panels>

            <div class="q-mt-sm text-right save-actions save-actions-bottom">
                <q-btn
                  color="white"
                  text-color="black"
                  label="Back"
                  @click="backAction"
                  v-if="step !='1'"
                />
                <q-btn
                  color="brand6"
                  :label="step === '3'?`Complete Order`:`Continue`"
                  @click="saveAction"
                  size="md"
                  class="q-px-md glossy"
                  :loading="saving"
                />
            </div>
          </div>
          <div class="col-md-3 col-12 q-px-sm order-details-box">
            <div class="row items-center order-details-inline">
              <strong>{{priceType}} </strong>
              <q-btn
                icon="edit"
                class="price-selection-link q-ml-sm"
                @click="priceTypeSelectionDialog = true"
                round outline size="xs"
              />
              <div class="row items-center">
                <span
                  class="text-bold text-brand6 total-price q-pl-md">
                  {{ selectedPrice | currency }}
                </span>
                <q-btn
                  outline color="brand6"
                  label="view details"
                  class="q-pa-none"
                  size="md"
                  flat
                  padding="xs"
                  @click="orderDetailsDialog = true"
                />
              </div>
            </div>

            <div class="order-details-main">
                <app-book-order-transport-details
                  :vehicles="vehicles"
                  :transport="transport"
                  :origin="origin"
                  :destination="destination"
                  :priceType="priceType"
                  @priceTypeChanged="setPriceType"
                />
            </div>

          </div>
        </div>

    </div>
    <div v-if="invalidLink">
      <h3 class="text-negative text-center">Sorry! This request is invalid!</h3>
    </div>
    <div v-if="isBooked">
      <app-order-booked-card
        :callNumberDisplay="callNumberDisplay"
        @dialPhone="dialPhone"
        :orderId="id"
      />
    </div>
  </div>
</template>
<script>
import { clientFacingOrderValidator } from '@client/validators';
import {
  extractKeysIntoObject,
  sanitizeObject
} from '@client/utils/object-helpers';
import graphql from '@client/graphql';
import delayTouch from '@client/utils/delay-touch';
import AppBookOrderCustomerInfo from '@client/components/book-order/customer-info';
import AppBookOrderLocationInfo from '@client/components/book-order/location-info';
import AppBookOrderTransportDetails from '@client/components/book-order/transport-details';
import AppTermsAndConditionCard from '@client/components/cards/terms-and-condition-card';
import AppBookOrderBillingAddress from '@client/components/book-order/billing-address';
import AppBookOrderCreditCardDetails from '@client/components/book-order/credit-card-details';
import AppOrderBookedCard from '@client/components/book-order/order-booked-card';

export default {
  name: 'AppBookOrder',
  components: {
    AppBookOrderCustomerInfo,
    AppBookOrderLocationInfo,
    AppBookOrderTransportDetails,
    AppTermsAndConditionCard,
    AppBookOrderBillingAddress,
    AppBookOrderCreditCardDetails,
    AppOrderBookedCard
  },
  validations: clientFacingOrderValidator,
  data() {
    return {
      isReady: false,
      step: '1',
      collapsed: {
        cust_info: false
      },
      saving: false,
      dirty: {},
      invalidLink: false,
      shipper: {},
      origin: {},
      destination: {},
      vehicles: [],
      transport: {},
      terms: {},
      billingAddress: {},
      creditCard: {},
      isOrder: false,
      isBooked: false,
      orderDetailsDialog: false,
      priceTypeSelectionDialog: false,
      engagements: [], // ["fullpay"],
      regularPriceText: `Once your order is assigned to a driver a partial payment of around $200.00 dollars will be charged. 
      The remaining balance will be due on delivery in either CASH, CERTIFIED BANK CHECK, or MONEY ORDER.`,
      discountedPriceText: `Once your order is assigned to a driver a partial payment of around $200.00 dollars will be charged. 
      The remaining balance will be due on delivery in either CASH, CERTIFIED BANK CHECK, or MONEY ORDER.`,
      callNumberDisplay: '(888) 424 - 4420',
      callNumber: '+18884244420'
    };
  },
  computed: {
    selectedPrice() {
        return this.engagements.length ?
                this.transport.regularPrice :
                this.transport.discountedPrice;
    },

    priceType() {
      return this.engagements.length ? 'regular' : 'discounted';
    },
    customerInfoClass() {
      if (this.$q.screen.lt.sm) return 'col-12';
      return 'col-6';
    },
    transportInfoClass() {
      if (this.$q.screen.lt.sm) return 'col-12 q-mb-sm';
      return 'col-6';
    },
    originInfoClass() {
      if (this.$q.screen.lt.sm) return 'col-12';
      return 'col';
    },
    destinationInfoClass() {
      if (this.$q.screen.lt.sm) return 'col-12';
      return 'col';
    },
    locationClass() {
      if (this.$q.screen.lt.sm) return 'q-gutter-y-sm';
      return 'row q-gutter-x-sm';
    },
    shippingClass() {
      if (this.$q.screen.lt.sm) return 'q-gutter-y-sm';
      return 'row q-gutter-x-sm';
    },
    billingInfoClass() {
      if (this.$q.screen.lt.sm) return 'q-gutter-y-sm';
      return 'row q-gutter-x-sm';
    }
  },
  async mounted() {
    // const payType = this.$route.query.pay;
    // if (payType && ['discounted', 'fullpay'].indexOf(payType) > -1) { // fullpay or discounted
    //   const engagements = payType === 'discounted' ? [] : ['fullpay'];
    //   await this.updateQuote({ engagements });
    //   const query = { ...this.$route.query };
    //   delete query.pay;
    //   this.$router.replace({ query });// remove pay from url
    // }
    const { token } = this.$route.params;
    if (!token) {
      this.$router.push({ name: 'home' });
      return;
    }

    const response = await this.$apollo.mutate({
      mutation: graphql.mutations.resolveBookOrderLink,
      variables: { encryption: token }
    });
    const { resolveBookOrderLink } = response.data;
    if (!resolveBookOrderLink) {
      this.invalidLink = true;
    } else {
      this.isBooked = resolveBookOrderLink.isBooked === true;
      Object.assign(this, {
        ...resolveBookOrderLink,
        terms: resolveBookOrderLink.terms || {}
      });
    }
    this.engagements = resolveBookOrderLink.engagements;
    this.handleUseInfo('shipper');
    this.isReady = true;
    this.scrollToTop();
  },
  methods: {
    async setPriceType(priceType) {
      const engagements = priceType === 'discounted' ? [] : ['fullpay'];
      await this.updateQuote({ engagements });
      this.engagements = engagements;
    },

    setDirty(target) {
      this.dirty[target] = true;
    },
    handleUseInfo(target) {
      const from = this[target];
      const billingAddress = extractKeysIntoObject(from, [
        'companyName',
        'firstName',
        'lastName',
        'email',
        'address',
        'city',
        'state',
        'zipcode'
      ]);
      if (from.name) {
        const nameArray = from.name.split(' ');
        [billingAddress.firstName] = nameArray;
        if (nameArray[1]) billingAddress.lastName = nameArray[nameArray.length - 1];
      }
      this.$set(this, 'billingAddress', billingAddress);
    },

    copyShipperToLocation(model) {
      const from = this.shipper;
      const name = `${from.firstName} ${from.lastName}`;
      this.$set(model, 'name', name);
      if (from.address) this.$set(model, 'address', from.address);
      this.$set(model, 'phone', from.phone);
      if (from.phone2) {
        this.$set(model, 'phone2', from.phone2);
      }
    },
    updateQuote(data) {
      const { token } = this.$route.params;

      const payload = Object.keys(data).reduce((acc, key) => {
        acc[key] = data[key];

        if (acc[key].phone && acc[key].phone.charAt(0) !== '+') {
          acc[key].phone = `+1${acc[key].phone}`;
        }
        if (acc[key].phone2 && acc[key].phone2.charAt(0) !== '+') {
          acc[key].phone2 = `+1${acc[key].phone2}`;
        }
        return acc;
      }, {});

      return this.$apollo.mutate({
        mutation: graphql.mutations.updateQuoteByCustomer,
        variables: {
          encryption: token,
          input: payload
        }
      });
    },
    saveAction() {
      if (+this.step === 1) {
        this.handleSaveShipperInfo();
      } else if (+this.step === 2) {
        this.handleSaveTerms();
      } else if (+this.step === 3) {
        this.handleBookOrder();
      }
      this.isOrder = true;
    },
    backAction() {
      this.setStep(+this.step - 1);
    },
    async handleSaveShipperInfo() {
      this.validate(['shipper', 'origin', 'destination']);

      if (!this.dirty.shipper) {
        if (!this.isOrder) {
           await this.updateQuote({});
        }
        this.setStep(2);
      } else {
        this.saving = true;

        try {
          const inputData = extractKeysIntoObject(this, [
            'shipper',
            'origin',
            'destination'
          ]);
          const shipper = extractKeysIntoObject(inputData.shipper, [
            'firstName',
            'lastName',
            'email',
            'phone',
            'phone2',
            'note'
          ]);
          const origin = extractKeysIntoObject(inputData.origin, [
            'name',
            'address',
            'phone',
            'phone2'
          ]);
          const destination = extractKeysIntoObject(inputData.destination, [
            'name',
            'address',
            'phone',
            'phone2'
          ]);
          await this.updateQuote({
            shipper: sanitizeObject(shipper),
            origin: sanitizeObject(origin),
            destination: sanitizeObject(destination)
          });
          this.$set(this.dirty, 'shipper', false);
          this.setStep(2);
        } catch (error) {
          this.notifyNegative(error.message);
        }

        this.saving = false;
      }
    },
    async handleSaveTerms() {
      this.validate(['terms']);

      if (!this.dirty.terms) {
        this.setStep(3);
      } else {
        this.saving = true;

        try {
          const inputData = extractKeysIntoObject(this, ['terms']);
          await this.updateQuote({
            terms: sanitizeObject(inputData.terms)
          });
          this.$set(this.dirty, 'terms', false);
          this.setStep(3);
        } catch (error) {
          this.notifyNegative(error.message);
        }

        this.saving = false;
      }
    },
    async handleBookOrder() {
      this.validate(['billingAddress', 'creditCard']);

      this.saving = true;
      if (this.dirty.billing) {
        try {
          const inputData = extractKeysIntoObject(this, [
            'billingAddress',
            'creditCard'
          ]);
          await this.updateQuote({
            billingInformation: {
              billingAddress: sanitizeObject(inputData.billingAddress),
              creditCard: sanitizeObject(inputData.creditCard)
            }
          });
          this.$set(this.dirty, 'billing', false);
          this.isBooked = true;
        } catch (error) {
          console.log(error);
          this.notifyNegative(error.message);
        }
      }
      this.saving = false;
    },
    setStep(i) {
      this.step = `${i}`;
    },
    scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    dialPhone() {
      window.open(`rcmobile://call?number=${this.callNumber}`);
    },
    delayTouch
  },
  watch: {
    step: function () {
      this.scrollToTop();
    }
  }
};
</script>
<style lang="scss">
  .book-order-header{
    position: fixed;
  }
  .heading-text{
    font-size: 18px;
  }
  .expansion-header{
    border-bottom: 1px solid #ddd;
  }

  .card-title{
    margin:0;
    line-height: 1;
    font-size: 2rem;
  }
  .book-order-box{
    font-size: 15px;
  }
  .text-subtitle2{
    font-size: 16px;
    font-weight: 900;
  }
  .text-subtitle1{
    font-size: 18px;
  }
  .text-h4{
    font-size:2.8rem;
  }
  .price-box{
    margin:auto
  }
  .q-panel>div{
    height: auto;
  }
  .q-tab-panel{
    padding:0;
  }
  .section-heading{
    margin-top:0;
    margin-bottom: 20px;
    line-height: 1;
    font-size: 20px;
  }
  .expansion-list-panel{
    height: atuo;
  }
  .expansion-list{
    background: #fff;
  }
  .book-order-box .q-field{
    padding-bottom: 10px;
  }
  .book-order-box .q-tab-panels{
    background:transparent;
  }
  .book-order-logo-box img {
    width: clamp(50px, 250px, 300px);
  }
  .order-details-inline{
    display: none;
  }

  .order-details-dialog{
    display: none;
  }
  .save-actions-top{
    margin-bottom:8px;
    margin-left: auto;
  }
  .save-actions-bottom{
    margin-top:8px;
  }

  .price-type-box{
    position: relative;
    outline:2px solid transparent;
    cursor: pointer;
  }
  .price-type-box.selected{
    outline-color: var(--brand-6-color);
  }
  .selected-price-icon{
    position: absolute;
    display: block;
    transition: opacity 400ms;
    left:5px;
    top:5px;
  }
  .price-type-box.selected .selected-price-icon{
    opacity: 1;
  }
  .check-cirlce.selected-price-icon {
    border: 3px solid  var(--brand-6-color);
    width: 30px;
    aspect-ratio: 1;
    border-radius: 50%;
    left: 9px;
    top:9px;
  }
  .price-type-heading{
    font-weight: bolder;
    font-size: 25px;
  }

  .p-relative{
    position: relative;
  }
  .semi-bordered-bottom,.expansion-header .q-item__label{
    position: relative;
    width: fit-content;
    padding-bottom: 8px;
  }
  .semi-bordered-bottom:hover::before,.expansion-header .q-item__label:hover::before{
    width: 100%;
    left: 0%;
  }

  .semi-bordered-bottom::before,.expansion-header .q-item__label::before{
    content: "";
    position: absolute;
    left: 10%;
    bottom: 0;
    width: 80%;
    height: 2px;
    background-color: var(--brand-5-color);
    transition: all 400ms cubic-bezier(0.075, 0.82, 0.165, 1);
  }

  .dialable-box{
    cursor: pointer;
  }

  @media (max-width: 1023px) {
    .book_order_main_first .order-details-box{
      order:-1;
      margin-bottom:30px;
    }
  }
</style>
